import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });
api.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Tab-local company context. Each dispatched request keeps its own workspace header.
export const setApiCompany = (id) => {
  if (id) api.defaults.headers.common["X-Company-ID"] = id;
  else delete api.defaults.headers.common["X-Company-ID"];
};

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    if (status === 402 && !error.config?.quiet402) {
      const detail = error.response.data?.detail || "This feature needs a higher plan.";
      window.dispatchEvent(new CustomEvent("tenx:upgrade-required", { detail: { message: detail } }));
    }
    if (status === 401) {
      const url = error.config?.url || "";
      const path = window.location.pathname;
      const isAuthProbe = url.includes("/auth/me") || url.includes("/auth/login") ||
        url.includes("/auth/register") || url.includes("/auth/change-password");
      const inApp = path.startsWith("/app") || path.startsWith("/portal");
      // Only treat as an expired session when an authenticated area makes a real call.
      if (!isAuthProbe && inApp) {
        window.location.assign("/login?expired=1");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
